import config from '~/config';
import Raven from 'raven-js';
import { ENVIRONMENT_MAP } from '~/constants/ModelConstants';

const activeEnvironment = config.ENVIRONMENT;

if (activeEnvironment !== ENVIRONMENT_MAP.ONPREM) {
  Raven.config(config.SENTRY_URL).setRelease(config.RELEASE_ID).install();
  require('./gtm.js');
}
